export const variants = {
	primary: "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90",
	outline:
		"border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
	ghost: "hover:bg-accent hover:text-accent-foreground",
};

export const sizes = {
	sm: "h-7 rounded-md px-3",
	md: "h-10 px-4 py-2",
	lg: "h-11 rounded-md px-8",
};

export const colorStyle = {
	red: "bg-red-100 text-red-700 hover:bg-red-200",
};
